export const inputFieldsLogin = [
  {
    field: 'emailOrCpf',
    label: 'E-mail, CPF ou CNPJ',
    placeholder: 'Digite seu e-mail, CPF ou CNPJ',
    type: 'text',
  },
  {
    field: 'password',
    label: 'Senha',
    placeholder: 'Digite sua senha',
    type: 'password',
  },
];
